import { borderRadius } from '#/common/hooks/useClientTheme';
import { color } from '@nuvolo/nuux-theme/utils';
import styled from 'styled-components';

const Styles = styled.div`
  .dx-header-filter-empty {
    opacity: 0.5;
  }
  height: 100%;
  .dx-datagrid {
    .dx-checkbox.dx-state-hover .dx-checkbox-icon {
      border-color: ${color('custom', 'contrastText')} !important;
    }
    .dx-header-row .dx-header-filter-indicator.dx-text-content-alignment-left,
    .dx-header-row .dx-sort-indicator.dx-text-content-alignment-left {
      margin-right: 6px !important;
    }
    background-color: ${color('custom', 'cardBackground')};
    td[role='columnheader'].dx-cell-focus-disabled:focus:not(:focus-visible),
    td[role='columnheader'].dx-datagrid-action:focus:not(:focus-visible) {
      border-color: none;
      outline-color: none;
    }

    td[role='columnheader'].dx-cell-focus-disabled:focus-visible,
    td[role='columnheader'].dx-datagrid-action:focus-visible {
      border-color: ${color('secondary', 'dark2')};
      outline-color: ${color('secondary', 'dark2')};
    }

    td[role='columnheader'].dx-datagrid-action.dx-state-focused:focus-visible,
    td[role='columnheader'].dx-cell-focus-disabled.dx-state-focused:focus-visible {
      border-color: ${color('secondary', 'dark2')};
      outline-color: ${color('secondary', 'dark2')};
    }

    .nuvo-grid-toolbar-btn.dx-state-disabled {
      opacity: 0.3;
    }
    .dx-editor-cell:first-child {
      // border-left: none;
    }
    .dx-row.dx-datagrid-filter-row > td:not(:first-child):not(:last-child) {
      border-left: none !important;
      border-right: none !important;
    }
    .dx-row.dx-datagrid-filter-row > td:last-child:not(:first-child) {
      border-left: none !important;
    }
    .dx-datagrid-headers .dx-header-row > td:not(:last-child):not(:first-child),
    .dx-datagrid-rowsview .dx-row > td:not(:last-child):not(:first-child) {
      border-left: none !important;
      border-right: none !important;
    }
    .dx-datagrid-headers .dx-header-row > td:last-child:not(:first-child),
    .dx-datagrid-rowsview .dx-row > td:last-child:not(:first-child) {
      border-left: none !important;
    }
    .dx-datagrid-headers .dx-header-row > td:first-child,
    .dx-datagrid-rowsview .dx-row > td:first-child,
    .dx-datagrid-table .dx-row > td:first-child {
      border-right: none !important;
    }
    .dx-datagrid-headers .dx-header-row > td:first-child,
    .dx-datagrid-rowsview .dx-row > td:first-child,
    .dx-datagrid-table .dx-row > td:first-child {
      border-left: 1px solid ${color('ui', 'light2')} !important;
    }
    .dx-command-select.dx-editor-cell.dx-editor-inline-block {
      border-right: none !important;
    }
    .dx-datagrid-rowsview .dx-row {
      border-top: 1px solid ${color('ui', 'light2')} !important;
      border-bottom: 1px solid ${color('ui', 'light2')} !important;
    }
    .dx-datagrid-rowsview .dx-row > td {
      height: 62px;
      border-bottom: 1px solid ${color('ui', 'light2')};
      padding: 14px 10px;
      a {
        font-size: 14px;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .dx-datagrid-rowsview .dx-master-detail-row > td,
    .dx-datagrid-rowsview .dx-master-detail-row > td.dx-master-detail-cell {
      height: auto !important;
      padding: 0 !important;
      overflow: visible;
      /* border-left: none !important; */
      /* border-right: 1px solid ${color('ui', 'light2')} !important; */
    }
    .dx-datagrid-rowsview .dx-data-row td.dx-editor-cell {
      padding: 0 !important;
    }
    .dx-datagrid-filter-row {
      .dx-texteditor-input-container {
        input {
          height: 44px;
        }
      }
    }

    .dx-item .dx-item-content .dx-icon,
    .dx-button .dx-icon,
    .dx-button .dx-icon,
    .dx-dropdowneditor-icon,
    .dx-searchbox .dx-icon-search::before {
      color: ${color('primary', 'dark3')};
    }

    .dx-button.dx-state-focused {
      background-color: ${color('primary', 'light3')};
    }

    .dx-datagrid-headers {
      * {
        // can't find border left on asset tag icon
        // border-left: none !important;
      }
      .dx-checkbox-container,
      .dx-checkbox-container * {
        border-left: initial !important;
      }
      .dx-row.dx-header-row {
        background-color: ${color('custom', 'dataGridHeaderBackground')};
      }
    }
    .dx-row.dx-datagrid-filter-row {
      background-color: ${color('custom', 'dataGridBackground')};
      .dx-command-select {
        width: 42px !important;
        min-width: 42px !important;
        border-left: 1px solid ${color('ui', 'light2')} !important;
        border-right: none !important;
      }
      .dx-editor-cell .dx-editor-container .dx-state-invisible {
        display: block !important;
      }
      .dx-editor-cell .dx-selectbox .dx-state-invisible {
        display: none !important;
      }
    }
    .dx-datagrid-header-panel {
      padding: 0;
      border: none;
      border-bottom-width: 0;
      padding: 6px 6px 8px;
      background-color: transparent;

      .dx-toolbar .dx-toolbar-items-container {
        background-color: ${color('contrast', 'light')};

        .dx-toolbar-before {
          font-size: 14px;
          color: ${color('ui', 'dark2')};
        }

        .nuvo-grid-toolbar-btn {
          &.dx-state-disabled {
            background-color: transparent;
          }
        }

        .dx-datagrid-group-panel .dx-group-panel-message {
          font-weight: normal;
          color: ${color('ui', 'light')};
        }

        .dx-datagrid-search-panel {
          margin: 0;
        }
      }
    }

    .dx-datagrid-headers {
      border-top-width: 0;
      border-right-width: 0;
    }

    .dx-datagrid-rowsview {
      border-right-width: 0;
      border-bottom-left-radius: ${borderRadius?.s};
      border-bottom-right-radius: ${borderRadius?.s};
      overflow: hidden;
    }

    /* Windows Chrome (classic GDI/Direct3D rasterizer) can render a 1px seam where the
       absolutely-positioned frozen-column overlay meets the scrollable content underneath;
       macOS's compositor doesn't show this. Forcing both layers onto the same GPU pixel
       grid removes the seam without touching layout. */
    .dx-datagrid-content-fixed,
    .dx-datagrid-content-fixed .dx-datagrid-table {
      transform: translateZ(0);
    }

    .dx-datagrid-pager {
      padding-top: 42px;
      background-color: ${color('custom', 'cardBackground')};
      border: none;

      .dx-selection {
        color: ${color('contrast', 'light')};
        background-color: #26282b;
        border-bottom: none;
      }
    }

    .dx-datagrid-filter-panel {
      background-color: ${color('contrast', 'light')};
    }

    .dx-datagrid-headers {
      border-top-left-radius: ${borderRadius?.s};
      border-top-right-radius: ${borderRadius?.s};
      overflow: hidden;
      .dx-header-filter {
        /* display: none; */
      }
    }
    .dx-header-row {
      td {
        height: 50px;
        padding: 14px 10px !important;
        border-bottom-color: ${color('primary', 'light')} !important;
        div {
          font-size: 12px;
          font-weight: 400;
        }
        .dx-datagrid-text-content {
          color: ${color('custom', 'dataGridHeaderText')} !important;
        }
      }
    }

    .dx-datagrid-pager.dx-pager {
      .dx-navigate-button.dx-prev-button.dx-button-disable {
        display: none;
      }
      .dx-pages {
        .dx-info {
          color: ${color('custom', 'paginationText')};
          opacity: 1;
        }
      }
      .dx-page-sizes {
        .dx-page-size {
          &:hover {
            background-color: ${color('custom', 'hoveredBackground')};
          }
        }

        div {
          font-size: 14px;
          border-radius: 8px;
          padding: 10px 10px;
        }

        &::after {
          content: 'Items per page';
          font-size: 14px;
          color: ${color('custom', 'paginationText')};
          margin-left: 8px;
        }
      }

      .dx-page {
        border-radius: ${borderRadius?.xs};
        &:hover {
          background-color: ${color('custom', 'hoveredBackground')};
        }
      }
    }

    .dx-datagrid-rowsview .dx-datagrid-table .dx-row.dx-freespace-row {
      display: none !important;
    }
    .dx-data-row {
      background-color: ${color('custom', 'dataGridBackground')};
      &:hover {
        background-color: ${color('custom', 'hoveredBackground')};
      }
    }
  }
  .dx-datagrid-nodata {
    background-color: ${color('custom', 'formImageWrapperBackground')};
    height: 520px;
    justify-content: center;
    align-items: center;
    display: flex;
    color: ${color('primary', 'dark')};
    font-size: 24px;
    font-weight: 600;
    text-transform: capitalize;
  }
  .dx-gridbase-container
    > .dx-datagrid-rowsview.dx-scrollable:has(.dx-datagrid-nodata:not(.dx-hidden)) {
    height: 520px;
    border-bottom-left-radius: 32px;
    border-bottom-right-radius: 32px;
  }
`;

export default Styles;
